import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LANG_SIGNAL, LsSectionBandComponent } from '@lyricstream/shared';
import { TranslateModule } from '@ngx-translate/core';
import { LyricListSectionComponent } from '../../ui/lyric-list-section/lyric-list-section.component';

@Component({
  selector: 'app-popular',
  imports: [TranslateModule, LsSectionBandComponent, LyricListSectionComponent],
  templateUrl: './popular.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopularComponent {
  protected readonly lang = inject(LANG_SIGNAL);
}
